// Dependecies
import { reject } from 'lodash';
import { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

// Store
import dynamicMenu from '../../store/dynamicMenu';

function useContentDynamic() {
  const [dynamicMenuStore, actions] = dynamicMenu();
  const [expandedMenu, setExpanded] = useState(dynamicMenuStore.stateMenuChange);
  const location = useLocation();
  const history = useHistory();
  const [selectedNav, setSelect] = useState(location.pathname.substr(4));

  useEffect(() => {
    actions.changeMenu(expandedMenu).then(
      (response) => {
        setExpanded(response.stateMenuChange);
      },
      (e) => {
        reject(e);
      }
    );
  }, [expandedMenu]);

  return {
    expandedMenu,
    location,
    history,
    selectedNav,
    setExpanded,
    setSelect,
  };
}

export default useContentDynamic;
